import styled from 'styled-components';

export const QuizWrap = styled.div`
  position: relative;

  > img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  > button {
    border: 0;
    background: transparent;
    width: 90%;
    height: 14%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    &.a-1 {
      bottom: 25%;
    }

    &.a-2 {
      bottom: 6%;
    }
  }
`;
